import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class PromotionsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "sourceSeasonId", 0);
    _defineProperty(this, "targetSeasonId", 0);
    _defineProperty(this, "loadingRivals", false);
    _defineProperty(this, "rivals", []);
    // Selection state
    _defineProperty(this, "relegatedIds", ['', '', '']);
    _defineProperty(this, "promotedIds", ['', '', '']);
    _defineProperty(this, "saving", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.seasons = this.attrs.seasons || [];
    if (this.seasons.length > 0) {
      this.sourceSeasonId = parseInt(this.seasons[0].id());
      this.targetSeasonId = parseInt(this.seasons[0].id());
      this.loadRivalsForSource();
    } else {
      this.loadingRivals = true;
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
      }).then(seasonsResp => {
        this.seasons = app.store.pushPayload(seasonsResp) || [];
        this.seasons.sort((a, b) => b.name().localeCompare(a.name()));
        if (this.seasons.length > 0) {
          this.sourceSeasonId = parseInt(this.seasons[0].id());
          this.targetSeasonId = parseInt(this.seasons[0].id());
          this.loadRivalsForSource();
        } else {
          this.loadingRivals = false;
          m.redraw();
        }
      }).catch(() => {
        this.loadingRivals = false;
        m.redraw();
      });
    }
  }
  className() {
    return 'PromotionsModal Modal--medium';
  }
  title() {
    return 'Gestión de Promociones (Ascensos y Descensos)';
  }
  onsubmit(e) {
    e.preventDefault();
    this.savePromotions();
  }
  onSourceSeasonChange(seasonId) {
    this.sourceSeasonId = seasonId;
    this.relegatedIds = ['', '', ''];
    this.promotedIds = ['', '', ''];
    this.loadRivalsForSource();
  }
  loadRivalsForSource() {
    this.loadingRivals = true;
    m.redraw();
    const selectedSeason = this.seasons.find(s => parseInt(s.id()) === this.sourceSeasonId);
    const seasonParam = selectedSeason ? selectedSeason.name().replace('/', '-') : '';
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals?season=".concat(seasonParam)
    }).then(response => {
      this.rivals = app.store.pushPayload(response) || [];
      this.loadingRivals = false;
      m.redraw();
    }).catch(err => {
      this.loadingRivals = false;
      console.error(err);
      m.redraw();
    });
  }
  savePromotions() {
    // Validate selections
    if (this.sourceSeasonId === this.targetSeasonId) {
      app.alerts.show({
        type: 'error'
      }, 'La temporada inicial y final no pueden ser la misma.');
      return;
    }
    const cleanRelegated = this.relegatedIds.filter(id => id !== '');
    const cleanPromoted = this.promotedIds.filter(id => id !== '');
    if (cleanRelegated.length !== 3 || cleanPromoted.length !== 3) {
      app.alerts.show({
        type: 'error'
      }, 'Debes seleccionar exactamente 3 equipos para descender y 3 para ascender.');
      return;
    }

    // Check for duplicates
    const uniqueRelegated = new Set(cleanRelegated);
    const uniquePromoted = new Set(cleanPromoted);
    if (uniqueRelegated.size !== 3 || uniquePromoted.size !== 3) {
      app.alerts.show({
        type: 'error'
      }, 'No puedes seleccionar el mismo equipo más de una vez.');
      return;
    }
    this.saving = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/promote-rivals',
      body: {
        source_season_id: this.sourceSeasonId,
        target_season_id: this.targetSeasonId,
        relegated_ids: cleanRelegated,
        promoted_ids: cleanPromoted
      }
    }).then(() => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, 'Ascensos y descensos aplicados correctamente para la temporada destino.');
      this.hide();
      if (this.attrs.onSave) {
        this.attrs.onSave();
      }
    }).catch(err => {
      this.saving = false;
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'Ha ocurrido un error al procesar las promociones.');
      m.redraw();
    });
  }
  content() {
    // Filter rivals
    const primeraRivals = this.rivals.filter(r => r.attribute('division') === '1ª');
    const segundaRivals = this.rivals.filter(r => r.attribute('division') === '2ª');
    return m("div", {
      className: "Form"
    }, m("div", {
      className: "Modal-body"
    }, m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px;"
    }, m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color);"
    }, "Temporada Inicial (Origen)"), m("select", {
      className: "FormControl",
      value: this.sourceSeasonId,
      onchange: e => this.onSourceSeasonChange(parseInt(e.target.value)),
      disabled: this.saving || this.loadingRivals,
      style: "border-radius: 8px;"
    }, this.seasons.map(s => m("option", {
      value: s.id()
    }, s.name())))), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color);"
    }, "Temporada Final (Destino)"), m("select", {
      className: "FormControl",
      value: this.targetSeasonId,
      onchange: e => {
        this.targetSeasonId = parseInt(e.target.value);
        m.redraw();
      },
      disabled: this.saving,
      style: "border-radius: 8px;"
    }, this.seasons.map(s => m("option", {
      value: s.id()
    }, s.name()))))), this.loadingRivals ? m("div", {
      style: "text-align: center; padding: 30px 0;"
    }, m(LoadingIndicator, null)) : m("div", null, m("div", {
      style: "background: rgba(244, 67, 54, 0.05); border: 1px solid rgba(244, 67, 54, 0.15); border-radius: 12px; padding: 15px; margin-bottom: 20px;"
    }, m("h4", {
      style: "margin: 0 0 12px 0; font-weight: bold; color: #ff8a80; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-arrow-down"
    }), " Descensos (1\xAA \u27A1\uFE0F 2\xAA)"), m("div", {
      style: "display: flex; flex-direction: column; gap: 10px;"
    }, [0, 1, 2].map(idx => m("select", {
      className: "FormControl",
      value: this.relegatedIds[idx],
      onchange: e => {
        this.relegatedIds[idx] = e.target.value;
        m.redraw();
      },
      disabled: this.saving,
      style: "border-radius: 8px;"
    }, m("option", {
      value: ""
    }, "-- Seleccionar Equipo --"), primeraRivals.map(r => m("option", {
      value: r.id(),
      disabled: this.relegatedIds.includes(String(r.id())) && this.relegatedIds[idx] !== String(r.id())
    }, r.name())))))), m("div", {
      style: "background: rgba(76, 175, 80, 0.05); border: 1px solid rgba(76, 175, 80, 0.15); border-radius: 12px; padding: 15px; margin-bottom: 20px;"
    }, m("h4", {
      style: "margin: 0 0 12px 0; font-weight: bold; color: #a5d6a7; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-arrow-up"
    }), " Ascensos (2\xAA \u27A1\uFE0F 1\xAA)"), m("div", {
      style: "display: flex; flex-direction: column; gap: 10px;"
    }, [0, 1, 2].map(idx => m("select", {
      className: "FormControl",
      value: this.promotedIds[idx],
      onchange: e => {
        this.promotedIds[idx] = e.target.value;
        m.redraw();
      },
      disabled: this.saving,
      style: "border-radius: 8px;"
    }, m("option", {
      value: ""
    }, "-- Seleccionar Equipo --"), segundaRivals.map(r => m("option", {
      value: r.id(),
      disabled: this.promotedIds.includes(String(r.id())) && this.promotedIds[idx] !== String(r.id())
    }, r.name())))))))), m("div", {
      className: "Modal-footer",
      style: "display: flex; gap: 10px; justify-content: flex-end;"
    }, m(Button, {
      className: "Button",
      onclick: () => this.hide(),
      disabled: this.saving,
      style: "border-radius: 8px;"
    }, "Cancelar"), m(Button, {
      className: "Button Button--primary",
      onclick: this.savePromotions.bind(this),
      loading: this.saving,
      disabled: this.loadingRivals || this.relegatedIds.filter(id => id !== '').length !== 3 || this.promotedIds.filter(id => id !== '').length !== 3,
      style: "border-radius: 8px; font-weight: bold; background-color: var(--primary-color); color: white;"
    }, m("i", {
      className: "fas fa-save",
      style: "margin-right: 6px;"
    }), " Guardar Promociones")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PromotionsModal', PromotionsModal);